export default __webpack_public_path__ + "static/media/rockstar.fcd4a8c1.jpg";